interface IAppConfig {
  Id: string;
  Authority?: string;
  MasterEndpointUrl: string;
  SaveEndpointUrl: string;
  OrderHistoryEndpointUrl: string;
}

// Shaligram
const ShaligramApp: IAppConfig = {
  Id: '41e95f2e-ac7a-46ed-813d-573410765f63',
  Authority: undefined,
  MasterEndpointUrl: 'https://prod-78.westeurope.logic.azure.com/workflows/b67b8cc7230f4e2fa650ab93a043de92/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=_470w4bHGUwwzscjNpdYVNM4W6B4BbjJygwHsHGtcjM',
  SaveEndpointUrl: 'https://prod-95.westeurope.logic.azure.com/workflows/c1a63efc8e5c4a4b994459f7e4f81991/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=jPVVpZ7afH2ykUMi2sGVWVAuETb145VM1LlwXhn2ql4',
  OrderHistoryEndpointUrl: 'https://prod-48.westeurope.logic.azure.com/workflows/8c4895f976f54e3e8a141a4ac94c76b4/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=CXNhlur1GKHVuPCO6bRzixj3rRKIz7XcYpY8lmP3mAA'
};

// Irrus
const IrrusApp: IAppConfig = {
  Id: 'cf9f5e03-9852-48ae-ac65-9327beb76090',
  Authority: 'https://login.microsoftonline.com/a6486344-465e-45f0-a7f5-d6e2bb595e55',
  MasterEndpointUrl: 'https://prod-78.westeurope.logic.azure.com/workflows/b67b8cc7230f4e2fa650ab93a043de92/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=_470w4bHGUwwzscjNpdYVNM4W6B4BbjJygwHsHGtcjM',
  SaveEndpointUrl: 'https://prod-95.westeurope.logic.azure.com/workflows/c1a63efc8e5c4a4b994459f7e4f81991/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=jPVVpZ7afH2ykUMi2sGVWVAuETb145VM1LlwXhn2ql4',
  OrderHistoryEndpointUrl: 'https://prod-48.westeurope.logic.azure.com/workflows/8c4895f976f54e3e8a141a4ac94c76b4/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=CXNhlur1GKHVuPCO6bRzixj3rRKIz7XcYpY8lmP3mAA'
}

// Mansveld
const MansveldApp: IAppConfig = {
  Id: '148c86e4-8bdf-49b7-a6f6-c52e4eb5f2b4',
  Authority: 'https://login.microsoftonline.com/bca71bac-28f4-401d-b0c6-6f88d3397982',
  MasterEndpointUrl: 'https://prod-68.westeurope.logic.azure.com:443/workflows/ebaf11d555ca497aaaa5d99df4dd8cee/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=wO1hmMqCGu-U54m4wnOvhu_yFpMUQp0ITked4ah391c',
  SaveEndpointUrl: 'https://prod-98.westeurope.logic.azure.com:443/workflows/042ada56c7634ea8b2d71f9534f1e33a/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=zCFuQop61_g6Hfj2iw2cXOCdI3hq7kU7YcJpXCv0v_g',
  OrderHistoryEndpointUrl: 'https://prod-84.westeurope.logic.azure.com:443/workflows/b6226b07a0cf4a1e9a7d8a03fe0bf55d/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=I0rZnack4BhFSD4OfmORvmMzitXBMDgKO7h_JAhi3Yo'
}

// set your environment here:
const appConfig: IAppConfig = MansveldApp;

export const Authority: string | undefined = appConfig.Authority;
export const AppId: string = appConfig.Id;
export const Scopes: Array<string> = [
    "user.read"
  ];
export const baseUrlMasters = appConfig.MasterEndpointUrl;
export const baseUrlSaveOrderAndItems = appConfig.SaveEndpointUrl;
export const baseUrlOrderHistory = appConfig.OrderHistoryEndpointUrl;
